import initialState from './state.js';

export default {
    resetState(state) {
        initialState.authUser = {};
        Object.assign(state, initialState);
    },

    setAuthUser(state, authUser) {
        state.authUser = authUser;
    },

    setLicenseTypes(state, licenseTypes) {
        state.licenseTypes = licenseTypes;
    },

    addOrder(state, order) {
        state.orders.unshift(order);
    },

    addLicenseType(state, type) {
        state.licenseTypes.push(type);
    },

    addClient(state, client) {
        state.authUserLicenseTypes = client.license_types;
    },

    setOrders(state, orders) {
        state.orders = orders;
    },

    changeLicensePage(state, page) {
        state.pagination.licenseCurrentPage = page;
    },

    setPageTitle(state, pageTitle) {
        state.pageTitle = pageTitle;

        // Set document title
        let title = 'ApexO';

        if (pageTitle && (state.authUser.locale || router.currentRoute.meta.auth)) {
            title = `${pageTitle} | ${title}`;
        }

        document.title = title;
    },

    decreaseLicenseTypeUnactivatedCount(state, licenseTypeId) {
        const licenseType = state.licenseTypes.find(type => type.id == licenseTypeId);

        licenseType.unactivatedLicenses -= 1;
    },
};
